import React from "react";
import { graphql } from "gatsby";
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon";
import parse from "html-react-parser";
import StructuredText from "../custom-structured-text-renderer";
import { RightArrow } from "../../icons";

const Partnership = ({title, items}) => {
  return (
    <section className="partnership">
      <div className="partnership__inner">
        {title && <h2>{parse(title)}</h2>}
        <div className="partnership__items">
          {
            items?.length > 0 && items.map((el, i) => (
              <div key={i} className="partnership__item" data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                <div className="partnership__item-image">
                  {el.image && <Asset asset={el.image}/>}
                </div>

                {el.logo && <Asset className="icon" asset={el.logo}/>}
                {el.title && <h3>{el.title}</h3>}
                {el.richContent && <StructuredText data={el.richContent}/>}
                {el.button.length > 0 && <Link
                  to={el.button[0].link[0]?.externalLink ? el.button[0].link[0]?.externalLink : el.button[0].link[0]?.internalLink?.permalink}
                  target='_blank'
                  rel='noopener noreferrer'>
                  {el.button[0].title}
                  <RightArrow color="#0D2E7A"/>
                </Link>}
              </div>
            ))
          }
        </div>
      </div>
    </section>
  )
}

export default Partnership

export const query = graphql`
fragment PartnershipProps on DatoCmsPartnership {
  ... on DatoCmsPartnership {
    id
    title
    items {
      title
      richContent {
        value
      }
      logo {
        ...InternalAssetProps
      }
      image {
        ...InternalAssetProps
      }
      button {
        ...LinkWithTitleProps
      }
    }
  }
}
`